export default "__VITE_ASSET__CYMu2JQM__"